import { fetchAPI } from '.'

export interface UserStatsResponse {
  week_streak: number
  day_streak: number
  total_words: number
  total_duration: number
  total_non_empty_duration: number
  words_per_minute: number
  last_transcript_timestamp: string
  words_this_week: number
  is_initialized: boolean
  created_at: string
  modified_at: string
  total_apps: string[]
}

export interface EnterpriseUserUsage {
  user_id: string
  email: string
  first_name: string
  last_name: string
  stats: UserStatsResponse | null
  daily_word_counts: DailyWordCount[]
}

export interface DailyWordCount {
  day: string
  wordcount: number
}

export interface EnterpriseUsageResponse {
  users: EnterpriseUserUsage[]
  total_count?: number
  team_member_count?: number
  offset?: number
  limit?: number
}

export async function getEnterpriseUsage() {
  return fetchAPI<EnterpriseUsageResponse>({
    method: 'GET',
    url: '/history/stats/enterprise',
  })
}
